import React, { useEffect, useLayoutEffect, useState } from "react";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { ReactComponent as CrosIconCustHome } from "../../assets/images/crosIconCustHome.svg";

import GeneralInfoSvg from "../../assets/images/icons/GeneralInfoSvg";
import GeneralLink from "../../assets/images/icons/GeneralLink";
import GeneralAddress from "../../assets/images/icons/GeneralAddress";
import GeneralContactPerson from "../../assets/images/icons/GeneralContactPerson";
import CustomerSocialModel from "../customer/CustomerSocialModel";
import CustomerAddressModel from "../customer/CustomerAddressModel";
import CustomerContactPersonModel from "../customer/CustomerContactPersonModel";
import { CUSTOMER_DETAILS_DATA } from "../../utils/constants";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import {
  useCustomerEditMutation,
  useCustomerTableMutation,
  useDeleteCustomerDataMutation,
} from "../../utils/customer/customerTable";
import NewAddIconBlue from "../../assets/images/icons/NewAddIconBlue";
import EditPencilIcon from "../../assets/images/icons/EditPencilIcon";
import CustomerGenInfo from "../customer/CustomerGenInfo";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import { ReactComponent as Blackplusicon } from "../../assets/images/icons/Blackplusicon.svg";
import AddGroupDrawer from "./AddGroupDrawer";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as DisclaimerImg } from "../../assets/images/Disclaimer.svg";
import { useFetchCustomerGroupQuery } from "../../utils/customer/customerTaskTable";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";

const validationRules = {
  customer_code: {
    required: true,
    errorMessage: "Tax No is required.",
  },
  phone: [
    {
      required: true,
      errorMessage: "Phone Number is required.",
    },
    {
      number: true,
      errorMessage: "Phone Number should contain only digits.",
    },
    {
      maxDigits: 15,
      errorMessage: "Must be between 1 to 15 digits.",
    },
  ],
  email: [
    {
      required: true,
      errorMessage: "Email is required.",
    },
    {
      email: true,
      errorMessage: "Provide valid email",
    },
  ],
};

const CustomerInfoDrawer = ({
  open,
  onClose,
  isDuplicate,
  activeTab,
  isEditMode,
  setIsEditMode,
  addCustomerId,
  setAddCustomerId,
  refetchCustomerDataNode = () => {},
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [activeButton, setActiveButton] = useState(activeTab ? activeTab : "genInfo");
  const [deletePayload, setDeletePayload] = useState(false);
  const { token } = useRequireAuth();
  const dispatch = useDispatch();
  const [AllCustomerData, setAllCustomerData] = useState([]);
  const [refetchAllData, setRefetchAllData] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [CustomerTableDrop, { data: customerCommnData }] = useCustomerTableMutation();
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [groupEditData, setGroupEditData] = useState({});

  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);

  const [customerData, setCustomerData] = useState({
    customer_group_id: "",
    customer_name: "",
    customer_display_name: "",
    website: "",
    type: "",
    customerFile: null,
    business_category: "",
    customer_code: "",
    country_id: "",
    phone: "",
    email: "",
    customerfile: "",
  });

  const {
    data: customerGroupData,
    error,
    isLoading,
  } = useFetchCustomerGroupQuery({ token, company_id: parsedCompanyData?.company_id });

  useEffect(() => {
    const custgrb = customerData?.customer_grp ? true : false;
    // setIsFormFrozen(custgrb);
  }, [customerData?.customer_grp]);

  useEffect(() => {
    if (customerGroupData?.data && Array.isArray(customerGroupData?.data)) {
      setCustomerGroups((prev) => [...prev, ...customerGroupData?.data]);
    }
  }, [customerGroupData]);

  const closeModal = () => {
    setValidationErrors("");
    onClose();
    setIsModalOpen(false);
  };

  // for closing drawer with escape Key
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const toggleActiveButton = (button) => {
    setActiveButton(button);
  };

  const handleAddButtonClick = () => {
    setIsEditMode(!isAddMode);
    setIsAddMode(!isAddMode);
  };

  const fetchAllData = async () => {
    try {
      const reposnse = await getCommonDataBasedOnId(`${CUSTOMER_DETAILS_DATA}${addCustomerId}`, token);
      setAllCustomerData(reposnse?.data[0]);
    } catch (error) {}
  };

  useEffect(() => {
    fetchAllData();
  }, [refetchAllData, addCustomerId]);

  const [customerEditMutation] = useCustomerEditMutation();
  const [deleteCustomerData] = useDeleteCustomerDataMutation();

  const AddUpdateData = async (payload) => {
    console.log("formValid valid payload", payload);
    try {
      const response = await customerEditMutation({ payload, token });
      if (activeButton === "genInfo") {
        setAddCustomerId(response?.data?.data?.id);
      }
      if (
        response?.data?.message === "Record updated successfully" ||
        response?.data?.message === "Record added successfully"
      ) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
        refetchCustomerDataNode();
        fetchAllData();
        setIsEditMode(false);
        setIsAddMode(false);
        setRefetchAllData((prev) => !prev);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "There is some problem.",
          type: "danger",
        })
      );
    }
  };
  const handleDeleteConfirmation = (payload, data) => {
    setDeletePayload(payload);
    setShowConfirmation(data);
  };

  const { data: customerGroup, refetch: refetchCustomerGroup } = useFetchCustomerGroupQuery({
    token,
    company_id: parsedCompanyData?.company_id,
  });

  const handleDelete = async (payload) => {
    setShowConfirmation(false);
    try {
      const response = await deleteCustomerData({
        payload,
        token,
      });
      if (response?.data?.success) {
        dispatch(pushAlert({ visible: true, message: response?.data?.message, type: "success" }));
        fetchAllData();
        setRefetchAllData((prev) => !prev);
        refetchCustomerDataNode();
      } else {
        dispatch(pushAlert({ visible: true, message: "Something Went Wrong.", type: "danger" }));
      }
    } catch (error) {
      console.error("Error updating status:", error);
      dispatch(
        pushAlert({
          visible: true,
          message: error || error?.message || error?.data?.message,
          type: "danger",
        })
      );
    }
  };

  const EmptyMessage = ({ Icon, Message, ButtonText }) => {
    return (
      <div className="flex flex-col h-full items-center justify-center text-center gap-2">
        {/* <div className="flex w-[127px] h-[92px] p-[14.242px_19px_14.345px_18.093px] justify-center items-center flex-shrink-0 border border-gray-300 rounded-lg"> */}
        <div className="">{Icon && <Icon className="w-full h-full" />}</div>
        <p className="mt-2 text-[#666666] font-Inter text-14">{Message}</p>
        <button
          className=" flex justify-center items-center gap-1  px-4 py-2 bg-white rounded-[58.846px] shadow-[inset_0px_1px_0px_0px_rgba(0,0,0,0.10),_0px_0px_4px_0px_rgba(0,0,0,0.15)] text-[#383838] border border-gray-300 hover:bg-gray-100 transition "
          onClick={handleAddButtonClick}
        >
          <Blackplusicon /> {ButtonText}
        </button>
      </div>
    );
  };

  const handleCancel = () => {
    setIsEditMode(false);
    setIsAddMode(false);
  };

  const handleGroupDrawerClose = () => {
    setIsAddingNew(false);
  };

  const parentRef = React.useRef(null);
  return (
    <CustomDrawer open={open} onClose={closeModal} disabled={isAddingNew}>
      <div className="bg-white w-full h-full z-10 flex flex-col" ref={parentRef}>
        <section className="scetion-1 flex justify-between p-3 w-full border-b border-BECBD3">
          <div>
            <h2 className="text-16 font-500 text-434852">
              {isDuplicate
                ? "Duplicate User"
                : addCustomerId
                  ? isEditMode
                    ? "Edit Customer"
                    : "General Info"
                  : "Add Customer"}
              {activeButton === "link" ? " - Links" : ""}
              {activeButton === "address" ? " - Address" : ""}
              {activeButton === "contact" ? " - Contacts" : ""}
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={handleAddButtonClick}
              // disabled={AddCustomer}
            >
              {activeButton === "genInfo" && !isEditMode ? (
                <EditPencilIcon />
              ) : activeButton !== "genInfo" || !isEditMode ? (
                <NewAddIconBlue isActive={isAddMode} />
              ) : null}
            </button>
            {/* <div
              className="group inline-block p-2 relative"
              onClick={() => {
                onClose();
              }}
            >
              <CrosIconCustHome className=" text-[#B9B9B9] font-9xl w-3 h-3" />

              <div className="absolute inset-0 rounded-full border-2 border-transparent group-hover:border-gray-500 group-hover:cursor-pointer transition-all duration-300 ease-in-out"></div>
            </div> */}
            <button
              onClick={onClose}
              type="button"
              className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              data-modal-hide="assets-modal"
            >
              <CloseModalImg className="w-3 h-3" />
              <span className="sr-only">Close modal</span>
            </button>
          </div>
        </section>
        <div className="section-2 flex flex-col grow min-h-0">
          {
            <div className="flex justify-between px-3 border-b border-BECBD3 pt-3 pb-2 bg-[#F3F5F7]">
              <div className="left-buttons  flex items-center gap-3  ">
                <button
                  onClick={() => {
                    if (!isDuplicate && addCustomerId) {
                      setIsEditMode(false);
                      toggleActiveButton("genInfo");
                    }
                  }}
                  //   className="flex flex-col items-center justify-center w-14 h-14 rounded-[5px] border border-[#D2DAE1] bg-white"
                  // >

                  className={`flex flex-col items-center justify-center w-20 h-20 rounded-[5px] border 
    ${!isDuplicate && addCustomerId && activeButton === "genInfo" ? "border-[#1D4469]" : "border-[#D2DAE1]"} bg-white`}
                >
                  <GeneralInfoSvg genInfoActive={!isDuplicate && addCustomerId && activeButton === "genInfo"} />
                  <span
                    className={`text-[10px] font-normal font-[Poppins] whitespace-nowrap mt-1 ${!isDuplicate && addCustomerId && activeButton === "genInfo" ? "text-[#1D4469]" : "text-gray-500"}`}
                  >
                    Gen Info
                  </span>
                </button>

                <button
                  onClick={() => {
                    if (!isDuplicate && addCustomerId) {
                      toggleActiveButton("link");
                      setIsEditMode(false);
                      setIsAddMode(false);
                    }
                  }}
                  //   className="flex flex-col items-center justify-center w-14 h-14 rounded-[5px] border border-[#D2DAE1] bg-white"
                  // >

                  className={`flex flex-col items-center justify-center w-20 h-20 rounded-[5px] border 
    ${!isDuplicate && addCustomerId && activeButton === "link" ? "border-[#1D4469]" : "border-[#D2DAE1]"} bg-white`}
                >
                  <GeneralLink linkActive={!isDuplicate && addCustomerId && activeButton === "link"} />
                  {/* <span className="text-[10px] font-normal text-gray-500 font-[Poppins] whitespace-nowrap">Link</span> */}
                  <span
                    className={`text-[10px] font-normal font-[Poppins] whitespace-nowrap mt-1 ${!isDuplicate && addCustomerId && activeButton === "link" ? "text-[#1D4469]" : "text-gray-500"}`}
                  >
                    Link
                  </span>
                </button>

                <button
                  onClick={() => {
                    if (!isDuplicate && addCustomerId) {
                      toggleActiveButton("address");
                      setIsEditMode(false);
                      setIsAddMode(false);
                    }
                  }}
                  //   className="flex flex-col items-center justify-center w-14 h-14 rounded-[5px] border border-[#D2DAE1] bg-white"
                  // >
                  className={`flex flex-col items-center justify-center w-20 h-20 rounded-[5px] border 
    ${!isDuplicate && addCustomerId && activeButton === "address" ? "border-[#1D4469]" : "border-[#D2DAE1]"} bg-white`}
                >
                  <GeneralAddress addressActive={!isDuplicate && addCustomerId && activeButton === "address"} />
                  {/* <span className="text-[10px] font-normal text-gray-500 font-[Poppins] whitespace-nowrap">
                    Address
                  </span> */}
                  <span
                    className={`text-[10px] font-normal font-[Poppins] whitespace-nowrap mt-1 ${!isDuplicate && addCustomerId && activeButton === "address" ? "text-[#1D4469]" : "text-gray-500"}`}
                  >
                    Address
                  </span>
                </button>

                <button
                  onClick={() => {
                    if (!isDuplicate && addCustomerId) {
                      toggleActiveButton("contact");
                      setIsEditMode(false);
                      setIsAddMode(false);
                    }
                  }}
                  //   className="flex flex-col items-center justify-center w-14 h-14 rounded-[5px] border border-[#D2DAE1] bg-white"
                  // >
                  className={`flex flex-col items-center justify-center w-20 h-20 rounded-[5px] border 
    ${!isDuplicate && addCustomerId && activeButton === "contact" ? "border-[#1D4469]" : "border-[#D2DAE1]"} bg-white`}
                >
                  <GeneralContactPerson contactActive={!isDuplicate && addCustomerId && activeButton === "contact"} />
                  {/* <span className="text-[10px] font-normal text-gray-500 font-[Poppins] whitespace-nowrap">
                    Contact
                  </span> */}
                  <span
                    className={`text-[10px] font-normal font-[Poppins] whitespace-nowrap mt-1 ${!isDuplicate && addCustomerId && activeButton === "contact" ? "text-[#1D4469]" : "text-gray-500"}`}
                  >
                    Contact
                  </span>
                </button>
              </div>
              <div className="cursor-pointer">
                <ToolTipComponent
                  text={
                    <div className="text-[#F84545] font-poppins text-[10px] not-italic font-normal leading-none">
                      *Link, Address & Contact are manage at group level
                    </div>
                  }
                >
                  <DisclaimerImg />
                </ToolTipComponent>
              </div>
            </div>
          }

          {activeButton === "genInfo" && (
            <CustomerGenInfo
              closeButton={onClose}
              isEditMode={isEditMode}
              setIsEditMode={setIsEditMode}
              addCustomerId={addCustomerId}
              setAddCustomerId={setAddCustomerId}
              customerGeneralData={AllCustomerData?.customer_data?.[0]}
              allCustomerData={AllCustomerData}
              onSave={AddUpdateData}
              isDuplicate={isDuplicate}
              handleDelete={handleDelete}
              isAddMode={isAddMode}
              setIsAddMode={setIsAddMode}
              isAddingNew={isAddingNew}
              setIsAddingNew={setIsAddingNew}
              groupEditData={groupEditData}
              setGroupEditData={setGroupEditData}
              customerGroup={customerGroup}
              handleGroupDrawerClose={handleGroupDrawerClose}
              refetchCustomerGroup={refetchCustomerGroup}
              open={open}
              // setShowConfirmation={setShowConfirmation}
              anchorParentRef={parentRef}
            />
          )}

          {activeButton === "link" && (
            <section className="section-Link grow min-w-0" id="link">
              <CustomerSocialModel
                isEditMode={isEditMode}
                setIsEditMode={setIsEditMode}
                addCustomerId={addCustomerId}
                setAddCustomerId={setAddCustomerId}
                customerSocialData={AllCustomerData?.customer_socials_links}
                onSave={AddUpdateData}
                handleCancel={handleCancel}
                handleDelete={handleDeleteConfirmation}
                isAddMode={isAddMode}
                setIsAddMode={setIsAddMode}
                setRefetchAllData={fetchAllData}
                EmptyMessage={EmptyMessage}
                setShowConfirmation={setShowConfirmation}
              />
            </section>
          )}

          {activeButton === "address" && (
            <section className="section-Address grow min-w-0 " id="address">
              <CustomerAddressModel
                isEditMode={isEditMode}
                setIsEditMode={setIsEditMode}
                addCustomerId={addCustomerId}
                setAddCustomerId={setAddCustomerId}
                CustomerAddressData={AllCustomerData?.customer_address_data}
                setRefetchAllData={fetchAllData}
                onSave={AddUpdateData}
                handleCancel={handleCancel}
                handleDelete={handleDeleteConfirmation}
                isAddMode={isAddMode}
                setIsAddMode={setIsAddMode}
                EmptyMessage={EmptyMessage}
              />
            </section>
          )}

          {activeButton === "contact" && (
            <section className="section-Contact grow min-w-0" id="contact">
              <CustomerContactPersonModel
                onClose={onClose}
                isEditMode={isEditMode}
                setIsEditMode={setIsEditMode}
                addCustomerId={addCustomerId}
                setAddCustomerId={setAddCustomerId}
                customerContactPersonData={AllCustomerData?.customer_contacts}
                onSave={AddUpdateData}
                handleCancel={handleCancel}
                handleDelete={handleDeleteConfirmation}
                isAddMode={isAddMode}
                setIsAddMode={setIsAddMode}
                EmptyMessage={EmptyMessage}
              />
            </section>
          )}
        </div>
      </div>
      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={() => handleDelete(deletePayload)}
          onClose={() => setShowConfirmation(false)}
          title="Delete Confirmation?"
          message={
            <>
              Are you sure you want to delete <br />
              <span className="font-medium">{activeButton}</span> -{" "}
              <span className="font-medium">{showConfirmation}</span> ?
            </>
          }
          confirmVariant="delete"
          iconVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}

      {/* removed for checking parraler drawer with small height  */}
      {/* {isAddingNew && (
        <AddGroupDrawer
          open={isAddingNew}
          onClose={handleGroupDrawerClose}
          groupEditData={groupEditData}
          setGroupEditData={setGroupEditData}
          refetch={refetchCustomerGroup}
        />
      )} */}
    </CustomDrawer>
  );
};

export default CustomerInfoDrawer;
